/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {Component, OnInit} from '@angular/core';
import {NbIconLibraries} from '@nebular/theme';
import {AnalyticsService} from './@core/utils/analytics.service';
import {SeoService} from './@core/utils/seo.service';

@Component({
	standalone: false,
	selector: 'ngx-app',
	template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

	constructor(private analytics: AnalyticsService, private seoService: SeoService, private iconLibraries: NbIconLibraries) {
		this.iconLibraries.registerFontPack('solid', {packClass: 'fas', iconClassPrefix: 'fa'});
		this.iconLibraries.registerFontPack('regular', {packClass: 'far', iconClassPrefix: 'fa'});
		this.iconLibraries.registerFontPack('light', {packClass: 'fal', iconClassPrefix: 'fa'});
		this.iconLibraries.registerFontPack('duotone', {packClass: 'fad', iconClassPrefix: 'fa'});
		this.iconLibraries.registerFontPack('brands', {packClass: 'fab', iconClassPrefix: 'fa'});

		this.iconLibraries.setDefaultPack('regular');
	}

	ngOnInit(): void {
		this.analytics.trackPageViews();
		this.seoService.trackCanonicalChanges();

	}

}
